import { render, staticRenderFns } from "./EditSeatingStrategyPreferredSeating.vue?vue&type=template&id=c6bfe9ba&"
import script from "./EditSeatingStrategyPreferredSeating.vue?vue&type=script&lang=js&"
export * from "./EditSeatingStrategyPreferredSeating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports